import {Box, CircularProgress, Stack, Typography} from '@mui/material'

import {SlaCommentDisplayItem} from '../../types'

import {SlaCommentsList} from './SlaCommentsList'

type SlaCommentsContentProps = {
  isLoading: boolean
  isError: boolean
  items: SlaCommentDisplayItem[]
  emptyMessage: string
  errorMessage: string
  onOpenVersions: (item: SlaCommentDisplayItem) => void
}

export const SlaCommentsContent = ({
  isLoading,
  isError,
  items,
  emptyMessage,
  errorMessage,
  onOpenVersions
}: SlaCommentsContentProps) => {
  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" py={2}>
        <CircularProgress size={24} />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography variant="body2" color="error">
        {errorMessage}
      </Typography>
    )
  }

  if (items.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyMessage}
      </Typography>
    )
  }

  return <SlaCommentsList items={items} onOpenVersions={onOpenVersions} />
}

type SlaCommentsContentContainerProps = SlaCommentsContentProps

export const SlaCommentsContentContainer = (props: SlaCommentsContentContainerProps) => {
  return (
    <Box sx={{maxHeight: '45vh', overflowY: 'auto', pr: 1}}>
      <SlaCommentsContent {...props} />
    </Box>
  )
}
